<template>
	<div class="flex items-center">
		<div
			:style="`background-color:${teeHex};width:15px;height:15px;border-radius:50px;border:1px solid #ccc;margin-right:5px;margin-left:5px;`"
		></div>
		<div v-if="teeName">{{ teeName }}</div>
	</div>
</template>
<script>
export default {
	name: "CourseTeeTitle",
	props: {
		teeHex: {
			type: String,
			required: true
		},
		teeName: {
			type: String,
			required: false
		}
	}
}
</script>
